module.exports = __webpack_public_path__ + "img/bg_people_home_02.ed073318.png";